import { ID_SKIN } from './constants';
import { updateCss } from './updateCss';

export function load(url = '', name = ID_SKIN) {
  if (!url) {
    return Promise.reject();
  }

  /**
   * si existe un <link>, ej:
   * <link rel="stylesheet" type="text/css" media="screen" id="edicom-theme-skin" href="/themes/ewc/edicomone.css" />
   */
  const elem = document.getElementById('edicom-theme-skin');
  if (elem?.nodeName === 'LINK') {
    return new Promise((resolve, reject) => {
      elem.onload = resolve;
      elem.href = url;
      setTimeout(() => {
        reject(`loadinh theme take too long`);
      }, 5000);
    });
  }

  /**
   * OLD METHOD
   * si no existe <link> entonces tratamos manualmente un <style> cargando el contenido como string.
   */
  return fetch(url, { method: 'GET', redirect: 'manual' })
    .then(response => {
      if (response.status === 404 || response.type === 'opaqueredirect') {
        throw new Error(`@edicom.theme.load theme not found: ${url}`);
      }
      if (!response.ok) {
        throw new Error(`@edicom.theme.load theme error ${response.status}: ${url}`);
      }
      return response.text();
    })
    .then((css = '') => {
      return updateCss(css, name);
    })
    .catch(error => {
      console.error(error);
    });
}
